import ActivityIndex from "@/views/directory/activity/ActivityIndex.vue";

const activity = [
    {
        path: '/activities',
        name: 'activity',
        component: ActivityIndex,
        meta: {
            requiresAuth: true,
            roles: ['Super Admin', 'Admin Office'], 
        },
    }
]

export default activity;